import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { fmtUSD } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";
import { Modal, Field, TextInput, SelectInput, AddButton } from "../components/Form";

const FTYPES = ["Unrestricted", "Temporarily Restricted", "Board Designated"];
const TONE = { "Unrestricted": "green", "Temporarily Restricted": "amber", "Board Designated": "blue" };

export default function Funds() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ fund_name: "", fund_type: "Unrestricted", purpose: "", beginning_balance: 0 });

  const load = () => api.get("/funds").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/funds", { ...form, beginning_balance: Number(form.beginning_balance), restriction_level: form.fund_type });
      toast.success("Fund created");
      setOpen(false);
      setForm({ fund_name: "", fund_type: "Unrestricted", purpose: "", beginning_balance: 0 });
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (!rows) return <Loader />;

  const columns = [
    { key: "fund_name", label: "Fund", className: "font-medium" },
    { key: "fund_type", label: "Restriction", render: (r) => <StatusBadge tone={TONE[r.fund_type]}>{r.fund_type}</StatusBadge> },
    { key: "purpose", label: "Purpose", className: "text-[#5C5C54]" },
    { key: "beginning_balance", label: "Beginning", align: "right", render: (r) => fmtUSD(r.beginning_balance) },
    { key: "revenue_received", label: "Revenue", align: "right", render: (r) => <span className="text-inflow">{fmtUSD(r.revenue_received)}</span> },
    { key: "expenses_charged", label: "Expenses", align: "right", render: (r) => <span className="text-outflow">{fmtUSD(r.expenses_charged)}</span> },
    { key: "ending_balance", label: "Ending Balance", align: "right", render: (r) => <span className="font-semibold">{fmtUSD(r.ending_balance)}</span> },
  ];

  return (
    <div>
      <PageHeader title="Fund Accounting" subtitle="Track resources by donor restrictions and board designations."
        action={<AddButton onClick={() => setOpen(true)} label="New Fund" testid="add-fund-btn" />} />
      <DataTable columns={columns} rows={rows} testid="funds-table" />

      <Modal open={open} onOpenChange={setOpen} title="New Fund" onSubmit={submit} busy={busy} testid="fund-modal">
        <Field label="Fund Name" span={2}><TextInput required value={form.fund_name} onChange={(e) => setForm({ ...form, fund_name: e.target.value })} /></Field>
        <Field label="Restriction Type"><SelectInput value={form.fund_type} onChange={(e) => setForm({ ...form, fund_type: e.target.value })} options={FTYPES} /></Field>
        <Field label="Beginning Balance"><TextInput type="number" value={form.beginning_balance} onChange={(e) => setForm({ ...form, beginning_balance: e.target.value })} /></Field>
        <Field label="Purpose" span={2}><TextInput value={form.purpose} onChange={(e) => setForm({ ...form, purpose: e.target.value })} /></Field>
      </Modal>
    </div>
  );
}
